import { AnimatePresence, motion } from "framer-motion";

export function segmentCaptions(text) {
  const sentences = text.match(/[^.!?…]+[.!?…]+["']?|[^.!?…]+$/g) || [text];
  const parts = [];
  sentences.forEach((s) => {
    const t = s.trim();
    if (!t) return;
    if (t.length <= 110) {
      parts.push(t);
      return;
    }
    let cur = "";
    t.split(/(?<=[,;—:])\s+/).forEach((p) => {
      if ((cur + " " + p).trim().length > 110) {
        if (cur) parts.push(cur.trim());
        cur = p;
      } else {
        cur = (cur + " " + p).trim();
      }
    });
    if (cur) parts.push(cur.trim());
  });
  const total = parts.reduce((a, p) => a + p.length, 0) || 1;
  let acc = 0;
  return parts.map((p) => {
    const start = acc / total;
    acc += p.length;
    return { start, end: acc / total, text: p };
  });
}

export const Captions = ({ text }) => (
  <div className="fixed bottom-20 sm:bottom-20 left-0 right-0 z-20 flex justify-center px-4 sm:px-8 pointer-events-none">
    <AnimatePresence mode="wait">
      {text && (
        <motion.div
          key={text}
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -6 }}
          transition={{ duration: 0.3, ease: "easeOut" }}
          className="max-w-3xl text-center bg-black/55 backdrop-blur-md border border-neutral-800/60 px-4 sm:px-6 py-2.5 sm:py-3"
          data-testid="live-caption"
        >
          <span className="font-mono text-[9px] tracking-[0.3em] uppercase text-[#dd6611] mr-3 align-middle">Xena</span>
          <span className="text-sm sm:text-lg font-light text-neutral-100 leading-snug align-middle">{text}</span>
        </motion.div>
      )}
    </AnimatePresence>
  </div>
);
